import React, { useCallback, useState, useEffect } from "react";
import { authAxios } from "../utils";
import {
  checkFileAttach,
  // getReports,
  // ListAction,
  // ListCommentURL,
  ticketAddComment,
  ticketAddCommentForReply,
  // usersListURL,
  usersListURLV2,
} from "../constants";
import {
  Avatar,
  Button,
  Card,
  Col,
  Form,
  Mentions,
  // message,
  Row,
  Upload,
  // notification,
  // Modal,
  Input,
  Select,
  DatePicker,
  Comment,
  Tooltip,
} from "antd";
import { EditOutlined, UploadOutlined } from "@ant-design/icons";
import { openNotificationWithIcon } from "./Function";
import debounce from "lodash/debounce";
import moment from "moment";
import reactStringReplace from "react-string-replace";
// import { Pie,Column } from '@ant-design/charts';
import Cookies from "universal-cookie";
import UpOutlined from "@ant-design/icons/lib/icons/UpOutlined";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import PaperClipOutlined from "@ant-design/icons/lib/icons/PaperClipOutlined";
import SearchOutlined from "@ant-design/icons/lib/icons/SearchOutlined";
import "./Component.css";
import { ModelEditComment } from "./EditComment";

const cookies = new Cookies();

const { Option } = Mentions;
const { Meta } = Card;
export const ButtonList = class ButtonList extends React.Component {
  render() {
    return this.state.lsBtn.map((item, i) => (
      <Button
        type="primary"
        key={i}
        style={{
          marginTop: 32,
          marginRight: 10,
          backgroundColor: item.color,
          border: "none",
        }}
        onClick={() =>
          this.props.getModal(
            this.props.ticketid,
            item.state_to,
            item.ticketCode,
            item.button,
          )
        }
      >
        {item.button}
      </Button>
    ));
  }
};

export const FileDinhKem = class FileDinhKem extends React.Component {
  state = {
    selectedFileList: [],
    selectedFileOtherList: [],
  };

  render() {
    const { selectedFileList, selectedFileOtherList } = this.state;
    const { layout, fileTemplateURL, fileTemplate, id_loaiyeucau } = this.props;
    const hasTemplate = fileTemplate.length > 0;
    const uploadFileRequest = ({ file, onSuccess, name }) => {
      setTimeout(() => {
        onSuccess("ok");
        Upload_File(file, name);
      }, 0);
    };
    const uploadOtherFileRequest = ({ file, onSuccess, data }) => {
      setTimeout(() => {
        onSuccess("ok");
        Upload_File_Other(file);
      }, 0);
    };
    const Upload_File = (file) => {
      if (
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        openNotificationWithIcon(
          "error",
          "Lỗi upload file",
          `${file.name} không phải là file excel`,
        );
        // message.error(`${file.name} không phải là file excel`);
      } else {
        var FormData = require("form-data");
        var data = new FormData();
        data.append("fileupload", file);
        data.append("id_loaiyeucau", id_loaiyeucau);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        authAxios(cookies.get("token"))
          .post(checkFileAttach, data, config)
          .then((res) => {
            if (res.data.check_file_blank == "True") {
              this.setState({ selectedFileList: file.fileList });
              this.setState({ selectedFile: file });
            } else {
              this.setState({ selectedFileList: [] });
              openNotificationWithIcon(
                "error",
                "Lỗi upload file",
                res.data.check_file_blank,
              );
              // message.error(res.data.check_file_blank)
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.props.history.push("/login");
            }
          });
      }
    };
    const Upload_File_Other = (file) => {
      // if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      //     message.error(`${file.name} không phải là file excel`);
      // } else {
      // console.log("ok")
      // this.setState({selectedFileOtherList: file.fileList});
      // this.setState({selectedFileOther: file});
      // }
    };
    const handleChangeOther = (info) => {
      let selectedFileOtherList = [...info.fileList];
      selectedFileOtherList = selectedFileOtherList;
      this.setState({ selectedFileOtherList });
    };

    const handleChange = (info) => {
      let selectedFileList = [...info.fileList];
      selectedFileList = selectedFileList.slice(-1);
      this.setState({ selectedFileList });
    };
    return (
      <>
        <Row>
          {hasTemplate ? (
            <>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  wrapperCol={{ ...layout.wrapperCol, offset: 3 }}
                  labelCol={{ ...layout.labelCol, offset: 3 }}
                  label="File mẫu"
                >
                  <a href={fileTemplateURL}>{fileTemplate}</a>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item label="File đính kèm" name="filedinhkem">
                  <Upload
                    accept=".xlsx, .xls"
                    fileList={selectedFileList}
                    onChange={handleChange}
                    customRequest={uploadFileRequest}
                  >
                    <Button icon={<UploadOutlined />} htmlType="button">
                      Nhấn để chọn file
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item label="File đính kèm khác" name="filedinhkemkhac">
                  <Upload
                    fileList={selectedFileOtherList}
                    onChange={handleChangeOther}
                    customRequest={uploadOtherFileRequest}
                  >
                    <Button icon={<UploadOutlined />} htmlType="button">
                      Tải lên file khác
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
            </>
          ) : (
            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
              <Form.Item
                wrapperCol={{ ...layout.wrapperCol, offset: 3 }}
                labelCol={{ ...layout.labelCol, offset: 3 }}
                label="File đính kèm khác"
                name="filedinhkemkhac"
              >
                <Upload
                  onChange={handleChangeOther}
                  fileList={selectedFileOtherList}
                  customRequest={uploadOtherFileRequest}
                >
                  <Button icon={<UploadOutlined />} htmlType="button">
                    Tải lên file khác
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          )}
        </Row>
      </>
    );
  }
};

export const AsyncMention = ({ ticketid, fetchTicketDetail }) => {
  // Nhập phản hồi cấp 1
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedFileUploadList, setselectedFileUploadList] = useState([]);
  const [form] = Form.useForm();

  const waitForAPIAddComment = async (data) => {
    return authAxios(cookies.get("token")).post(ticketAddComment, data);
  };
  const onSearch = (search) => {
    // setSearch(search)
    setLoading(!!search);
    setUsers([]);
    debounceLoadData(search);
  };

  const loadUsers = (key) => {
    if (!key) {
      setUsers([]);
      return;
    }
    authAxios(cookies.get("token"))
      .get(usersListURLV2, { params: { search: key, type_api: "tag_comment" } })
      .then((res) => {
        // const items = res.data;
        let items = res.data.filter((item) => item.is_active == true); // 251224 chỉ filter user hoạt động
        // if (search !== key) return;
        setUsers(items.slice(0, 20));
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };
  const debounceLoadData = useCallback(debounce(loadUsers, 400), []);

  const onFinish = (values) => {
    setLoading(true);
    const comment = values.comment;
    if (!comment) {
      openNotificationWithIcon("error", "Lỗi", "Bạn chưa nhập phản hồi");
      setLoading(false);
      return;
    }
    const FormData = require("form-data");
    const data = new FormData();
    data.append("ticket_id", ticketid);
    data.append("ticket_comment", comment);
    if (values.filedinhkemkhac && values.filedinhkemkhac.fileList.length > 0) {
      for (const file in values.filedinhkemkhac.fileList) {
        data.append(
          "att_file",
          values.filedinhkemkhac.fileList[file].originFileObj,
        );
      }
    } else {
      data.append("att_file", []);
    }
    waitForAPIAddComment(data)
      .then((res) => {
        form.resetFields();
        setselectedFileUploadList([]);
        fetchTicketDetail();
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Lỗi add comment ", err);
      });
  };

  const uploadFileRequest = ({ file, onSuccess, name }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const handleChange = (info) => {
    let selectedFileList = [...info.fileList];
    setselectedFileUploadList(selectedFileList);
    if (selectedFileList.length === 0) {
      form.setFieldsValue({
        filedinhkemkhac: null,
      });
    }
  };
  return (
    <Form form={form} name="comment" onFinish={onFinish}>
      <Form.Item name="comment">
        <Mentions
          style={{ width: "100%", minHeight: 50 }}
          autoSize
          loading={loading}
          onSearch={onSearch}
          placeholder={"Nhập phản hồi của bạn tại đây nếu có"}
        >
          {users.map((item) => (
            <Option
              key={item.username}
              value={item.username}
              className="antd-demo-dynamic-option"
            >
              {item.email ? (
                <span>
                  {" "}
                  {item.username} ({item.email})
                </span>
              ) : (
                <span> {item.username}</span>
              )}
            </Option>
          ))}
        </Mentions>
      </Form.Item>
      <Row>
        <Col sm={4} style={{ float: "left" }}>
          <Form.Item name="filedinhkemkhac" label="">
            <Upload
              fileList={selectedFileUploadList}
              onChange={handleChange}
              customRequest={uploadFileRequest}
              multiple
            >
              <a>
                <PaperClipOutlined />
                Đính kèm file
              </a>
            </Upload>
          </Form.Item>
        </Col>
        <Col sm={20}>
          <Form.Item style={{ float: "right" }}>
            <Button
              style={{ width: 100 }}
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Gửi
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export const ListComment = ({ CommentData, fetchTicketDetail }) => {
  const [editVisible, setEditVisible] = useState(false);
  const [editForm] = Form.useForm();
  const [editingItem, setEditingItem] = useState(null);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [typeComment, setTypeComment] = useState("");

  const handleEditComment = (item, lv_commmet) => {
    setTypeComment(lv_commmet);
    setEditingItem(item);
    // setFileList([]); // reset file mới
    // setOldFiles(Object.entries(item.att_file || {})); // giữ file cũ
    setEditVisible(true);
  };

  const putEditComment_1 = (values) => {
    setLoadingEdit(true);

    const comment = values.content_comment;
    if (!comment) {
      openNotificationWithIcon("error", "Lỗi", "Bạn chưa nhập phản hồi");
      return;
    }
    const FormData = require("form-data");
    const data = new FormData();
    data.append("comment_id", values.comment_id);
    data.append("content_comment", values.content_comment);
    if (values.att_file && values.att_file.length > 0) {
      values.att_file.forEach((file) => {
        data.append("att_file", file);
      });
    } else {
      data.append("att_file", []);
    }

    if (values.deleted_old_files && values.deleted_old_files.length > 0) {
      values.deleted_old_files.forEach((file) => {
        data.append("deleted_old_files", file);
      });
    } else {
      data.append("deleted_old_files", []);
    }

    // let get_form = form.getFieldsValue();
    authAxios(cookies.get("token"))
      .put(ticketAddComment, data)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Đã cập nhật thông tin phản hồi.",
          "",
        );
        setEditVisible(false);
        editForm.resetFields();
        setLoadingEdit(false);
        fetchTicketDetail();
      })
      .catch((err) => {
        setLoadingEdit(false);

        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
      });
  };

  const putEditComment_2 = (values) => {
    setLoadingEdit(true);

    const comment = values.content_comment;
    if (!comment) {
      openNotificationWithIcon("error", "Lỗi", "Bạn chưa nhập phản hồi");
      return;
    }
    const FormData = require("form-data");
    const data = new FormData();
    data.append("comment_id", values.comment_id);
    data.append("content_comment", values.content_comment);
    if (values.att_file && values.att_file.length > 0) {
      values.att_file.forEach((file) => {
        data.append("att_file", file);
      });
    } else {
      data.append("att_file", []);
    }

    if (values.deleted_old_files && values.deleted_old_files.length > 0) {
      values.deleted_old_files.forEach((file) => {
        data.append("deleted_old_files", file);
      });
    } else {
      data.append("deleted_old_files", []);
    }

    // let get_form = form.getFieldsValue();
    authAxios(cookies.get("token"))
      .put(ticketAddCommentForReply, data)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Đã cập nhật thông tin phản hồi.",
          "",
        );
        setEditVisible(false);
        editForm.resetFields();
        setLoadingEdit(false);
        fetchTicketDetail();
      })
      .catch((err) => {
        setLoadingEdit(false);

        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
      });
  };

  const BoxContent = ({ item, lv_commmet }) => {
    const [showFloatComment, setShowFloatComment] = useState(false);

    return (
      // Phần xem phản hồi cấp 1
      // Vì phản hồi cấp 2 dùng lại nên xét đk bỏ qua nút phản hồi cấp 2
      <Comment
        actions={
          lv_commmet == "1" && item.id
            ? [
                <span
                  key="comment-nested-reply-to"
                  onClick={() => setShowFloatComment(!showFloatComment)}
                >
                  Phản hồi
                </span>,
              ]
            : null
        }
        author={
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <a>
              {item.username +
                " - đã phản hồi " +
                moment(item.created).fromNow()}
            </a>
            {/* Phần chỉnh sửa phản hồi cấp 1 / 2 */}
            <Tooltip title={`Chỉnh sửa phản hồi cấp ${lv_commmet}`}>
              <span
                onClick={() => handleEditComment(item, lv_commmet)}
                className="edit-icon"
              >
                <EditOutlined />
              </span>
            </Tooltip>
          </span>
        }
        avatar={<Avatar src={item.avatar} alt={item.username} />}
        content={
          <>
            <p>
              {reactStringReplace(
                item.content,
                /(?=\s|[^])@([\w-]+)/g,
                (match, i) => (
                  <a key={match + i}>@{match}</a>
                ),
              )}
            </p>
            {Object.entries(item.att_file).length > 0 ? (
              <>
                {Object.entries(item.att_file).map(([key, value]) => (
                  <p>
                    <a href={value} target="_blank">
                      {key}
                    </a>
                  </p>
                ))}
              </>
            ) : null}
            {/* Phần nhập thông tin phản hồi cấp 2 */}
            {showFloatComment ? (
              <AsyncMentionComment
                commentid={item.id}
                fetchTicketDetail={() => fetchTicketDetail()}
              ></AsyncMentionComment>
            ) : null}
          </>
        }
      >
        {/* Phần xem phản hồi cấp 2 */}
        {item.item_comment && item.item_comment.length > 0 ? (
          <SingleComment comment={item.item_comment} lv_commmet="2" />
        ) : null}
      </Comment>
    );
  };

  const SingleComment = ({ comment, lv_commmet }) => {
    return comment.map((item, index) => (
      <BoxContent item={item} lv_commmet={lv_commmet} />
    ));
  };

  return (
    <>
      <SingleComment comment={CommentData} lv_commmet="1" />
      {editVisible && typeComment && (
        <ModelEditComment
          editForm={editForm}
          editVisible={editVisible}
          setEditVisible={setEditVisible}
          editingItem={editingItem}
          loadingEdit={loadingEdit}
          putEditComment={
            typeComment == "1" ? putEditComment_1 : putEditComment_2
          }
        />
      )}
    </>
  );
};

const { RangePicker } = DatePicker;

export const AdvancedSearchForm = ({
  Columns,
  lsStatus,
  paramsSearch,
  callBackFilter,
}) => {
  const [expand, setExpand] = useState(true);
  const [form] = Form.useForm();
  const getFields = (lsColumns) => {
    const children = [];
    const columns = lsColumns;
    let component = null;

    columns.filter((item) => item.canSearch).forEach((item, index) => {
      const searchTitle =
        item.searchTitle || (typeof item.title === "string" ? item.title : "");
      switch (item.type) {
        case "date":
          component = (
            <Form.Item name={item.filterKey} label={item.title}>
              <DatePicker style={{ width: "100%" }} format={"DD/MM/YYYY"} />
            </Form.Item>
          );
          break;
        case "date_range":
          component = (
            <Form.Item name={item.filterKey} label={item.title}>
              <RangePicker style={{ width: "100%" }} format={"DD/MM/YYYY"} />
            </Form.Item>
          );
          break;
        case "option":
          component = (
            <Form.Item name={item.filterKey} label={item.title}>
              <Select
                showSearch
                allowClear
                mode={item.mode}
                placeholder={`Chọn ${searchTitle}`}
                onChange={(values) => {
                  if (item.mode === "multiple" && values && values.length > 1) {
                    const lastValue = values[values.length - 1];
                    if (lastValue === "all") {
                      form.setFieldsValue({ [item.filterKey]: ["all"] });
                    } else if (values.includes("all")) {
                      form.setFieldsValue({
                        [item.filterKey]: values.filter((v) => v !== "all"),
                      });
                    }
                  }
                  form.submit();
                }}
                filterOption={(input, option) =>
                  String(option.children)
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                optionFilterProp="children"
              >
                {(item.lsOption || []).map((item, index) => (
                  <Select.Option value={item.value} key={index}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          );
          break;
        default:
          component = (
            <Form.Item name={item.filterKey} label={item.title}>
              <Input allowClear placeholder={`Nhập ${searchTitle}`} autoComplete={"off"} />
            </Form.Item>
          );
      }
      {
        if (item.canSearch) {
          children.push(
            <Col span={6} key={index} style={{ display: !expand && index >= 4 ? "none" : undefined }}>
              {component}
            </Col>,
          );
        }
      }
    });
    return children;
  };

  useEffect(() => {
    if (paramsSearch) {
      const initialValues = {};
      Columns.forEach((col) => {
        if (!col.canSearch) return;
        initialValues[col.filterKey] = paramsSearch[col.filterKey];
        if (col.type === "date" && paramsSearch[col.filterKey]) {
          initialValues[col.filterKey] = moment(paramsSearch[col.filterKey]);
        } else if (col.type === "date_range" && paramsSearch[col.filterKey]) {
          const range = paramsSearch[col.filterKey];
          if (Array.isArray(range) && range.length === 2) {
            initialValues[col.filterKey] = [moment(range[0]), moment(range[1])];
          }
        }
      });
      form.setFieldsValue(initialValues);
    }
  }, [paramsSearch, Columns, form]);

  const onFinish = (values) => {
    // values.columnSort = 'id'
    // values.typeSort = 'descend'
    callBackFilter(values);
  };

  return (
    <Form
      form={form}
      name="advanced_search"
      className="ant-advanced-search-form"
      layout="vertical"
      onFinish={onFinish}
      style={{ width: "100%" }}
    >
      <Row gutter={24}>{getFields(Columns)}</Row>
      <Row style={{ marginBottom: "10px" }}>
        <Col span={24} style={{ textAlign: "right" }}>
          <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
            Tìm kiếm
          </Button>
          <Button
            style={{ margin: "0 8px" }}
            onClick={() => {
              form.resetFields();
              form.submit();
            }}
          >
            Xóa
          </Button>
          <a
            style={{ fontSize: 12 }}
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {expand ? <UpOutlined /> : <DownOutlined />}
            {expand ? "Thu hẹp" : "Mở rộng"}
          </a>
        </Col>
      </Row>
    </Form>
  );
};

export const AsyncMentionComment = ({ commentid, fetchTicketDetail }) => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedFileUploadList, setselectedFileUploadList] = useState([]);
  const [form] = Form.useForm();

  const waitForAPIAddComment = async (data) => {
    return authAxios(cookies.get("token")).post(ticketAddCommentForReply, data);
  };
  const onSearch = (search) => {
    setSearch(search);
    setLoading(!!search);
    setUsers([]);
    debounceLoadData(search);
  };

  const loadUsers = (key) => {
    if (!key) {
      setUsers([]);
      return;
    }
    authAxios(cookies.get("token"))
      .get(usersListURLV2, { params: { search: key } })
      .then((res) => {
        const items = res.data.filter((item) => item.is_active == true);

        // if (search !== key) return;
        setUsers(items.slice(0, 20));
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);

        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };
  const debounceLoadData = useCallback(debounce(loadUsers, 400), []);

  const onFinish = (values) => {
    setLoading(true);
    const comment = values.comment;
    if (!comment) {
      openNotificationWithIcon("error", "Lỗi", "Bạn chưa nhập phản hồi");
      setLoading(false);
      return;
    }
    const FormData = require("form-data");
    const data = new FormData();
    data.append("comment_id", commentid);
    data.append("comment_content", comment);
    if (values.filedinhkemkhac && values.filedinhkemkhac.fileList.length > 0) {
      for (const file in values.filedinhkemkhac.fileList) {
        data.append(
          "att_file",
          values.filedinhkemkhac.fileList[file].originFileObj,
        );
      }
    } else {
      data.append("att_file", []);
    }
    waitForAPIAddComment(data)
      .then((res) => {
        form.resetFields();
        setselectedFileUploadList([]);
        fetchTicketDetail();
        setLoading(false);
      })
      .catch((err) => {
        console.log("Lỗi add comment ", err);
        setLoading(false);
      });
  };

  const uploadFileRequest = ({ file, onSuccess, name }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const handleChange = (info) => {
    let selectedFileList = [...info.fileList];
    setselectedFileUploadList(selectedFileList);
    if (selectedFileList.length === 0) {
      form.setFieldsValue({
        filedinhkemkhac: null,
      });
    }
  };
  return (
    <Form form={form} name="comment" onFinish={onFinish}>
      <Form.Item name="comment">
        <Mentions
          style={{ width: "100%", minHeight: 50 }}
          autoSize
          loading={loading}
          onSearch={onSearch}
          placeholder={"Nhập phản hồi của bạn tại đây nếu có"}
        >
          {users.map((item) => (
            <Option
              key={item.username}
              value={item.username}
              className="antd-demo-dynamic-option"
            >
              {item.email ? (
                <span>
                  {" "}
                  {item.username} ({item.email})
                </span>
              ) : (
                <span> {item.username}</span>
              )}
            </Option>
          ))}
        </Mentions>
      </Form.Item>
      <Row>
        <Col span={4} style={{ float: "left" }}>
          <Form.Item name="filedinhkemkhac" label="">
            <Upload
              fileList={selectedFileUploadList}
              onChange={handleChange}
              customRequest={uploadFileRequest}
              multiple
            >
              <a>
                <PaperClipOutlined />
                Đính kèm file
              </a>
            </Upload>
          </Form.Item>
        </Col>
        <Col span={20}>
          <Form.Item style={{ float: "right" }}>
            <Button
              style={{ width: 100 }}
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Gửi
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
